export {
  getFranchisePageBySlug,
  getFranchiseBySlug,
  buildSubtitle,
  canStreamEpisode,
  getLightFranchiseBySlug,
  formatDateWithSuffix,
} from './FranchiseService'
export type { FranchisePageData, LightFranchise, FranchiseExtended } from './FranchiseService'
